export const cloneObject = (obj) => {
  const clonedObj = { ...obj };
  delete clonedObj.id;
  delete clonedObj.createdAt;
  delete clonedObj.updatedAt;
  delete clonedObj.owner;
  delete clonedObj.groups;
  return clonedObj;
};

export const getInputForUpdate = (obj) => {
  const clonedObj = { ...obj };
  delete clonedObj.createdAt;
  delete clonedObj.updatedAt;
  delete clonedObj.owner;
  return clonedObj;
};

export const touchResource = (resource) => {
  return {
    ...resource,
    updatedAt: new Date().toISOString(),
  };
};
